var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFontDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.143 0 0 3.143 0 7C0 10.857 3.143 14 7 14C10.857 14 14 10.857 14 7C14 3.143 10.857 0 7 0ZM9.352 8.61C9.555 8.813 9.555 9.149 9.352 9.352C9.247 9.457 9.114 9.506 8.981 9.506C8.848 9.506 8.715 9.457 8.61 9.352L7 7.742L5.39 9.352C5.285 9.457 5.152 9.506 5.019 9.506C4.886 9.506 4.753 9.457 4.648 9.352C4.445 9.149 4.445 8.813 4.648 8.61L6.258 7L4.648 5.39C4.445 5.187 4.445 4.851 4.648 4.648C4.851 4.445 5.187 4.445 5.39 4.648L7 6.258L8.61 4.648C8.813 4.445 9.149 4.445 9.352 4.648C9.555 4.851 9.555 5.187 9.352 5.39L7.742 7L9.352 8.61Z",
    fill: "#EB001B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontDelete);
export default __webpack_public_path__ + "static/media/font-delete.128fedf0.svg";
export { ForwardRef as ReactComponent };